export const isLicenseManagementEnabled = (portalConfig) =>
  portalConfig?.enableLicenseManagement === true;

export const isMspLicenseManagementEnabled = (portalConfig) =>
  portalConfig?.enableMspLicenseManagement === true;
